'use client';

import dynamic from 'next/dynamic';

import Footer from './Footer';

const ShopListHeroBackground = dynamic(
  () =>
    import('../../assets/svg/shop/cooperationSVGs/ShopListHeroBackground').then(
      (m) => m.ShopListHeroBackground,
    ),
  {
    ssr: false,
  },
);

export const FooterWithBackground = () => {
  return (
    <Footer
      background={
        <ShopListHeroBackground className="stroke-borderPrimary pointer-events-none absolute top-0 right-0 h-full" />
      }
    />
  );
};
